module.exports = __webpack_public_path__ + "img/gift3-06-c1.97a66405.png";